import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  /** Ausente no último item: é a página atual. */
  to?: string;
}

/**
 * O caminho até a página, de onde se volta clicando. Genérico: quem usa monta
 * os itens, e este componente não sabe de prova nem de questão.
 *
 * O último item é a página atual (`aria-current="page"`), em texto. Nome longo
 * trunca com o nome inteiro no `title`, para o caminho não estourar a tela
 * estreita.
 */
export function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="Caminho">
      <ol className="flex min-w-0 flex-wrap items-center gap-1.5 text-sm">
        {items.map((item, index) => {
          const current = index === items.length - 1;
          return (
            <li
              key={`${index}-${item.label}`}
              className="flex min-w-0 items-center gap-1.5"
            >
              {index > 0 && (
                <span
                  aria-hidden="true"
                  className="text-(--color-text-secondary)"
                >
                  &gt;
                </span>
              )}
              {current || item.to === undefined ? (
                <span
                  aria-current={current ? 'page' : undefined}
                  title={item.label}
                  className="text-(--color-text-primary) truncate font-medium"
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  title={item.label}
                  className="text-(--color-accent) truncate hover:underline"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
